// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.6.0 (commit 31fd1c8c3346dfec38dfcc2e89c2ecf457cf26ff).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AcceptInviteReducer from "./accept_invite_reducer";
import ActivateAuthBackendReducer from "./activate_auth_backend_reducer";
import ApplyStripeSubscriptionReducer from "./apply_stripe_subscription_reducer";
import ClaimTaxApprovalReducer from "./claim_tax_approval_reducer";
import ClaimTaxEmailReducer from "./claim_tax_email_reducer";
import ClearAuthImportReducer from "./clear_auth_import_reducer";
import ClearPlaybookSyncReducer from "./clear_playbook_sync_reducer";
import CompleteTaxApprovalReducer from "./complete_tax_approval_reducer";
import CreateApiKeyReducer from "./create_api_key_reducer";
import CreateGlaciTagReducer from "./create_glaci_tag_reducer";
import CreateJoinRequestReducer from "./create_join_request_reducer";
import CreateOrganizationReducer from "./create_organization_reducer";
import CreatePlaybookReducer from "./create_playbook_reducer";
import CreateTaxExemptionReducer from "./create_tax_exemption_reducer";
import DeclineInviteReducer from "./decline_invite_reducer";
import DeleteApiKeyReducer from "./delete_api_key_reducer";
import DeleteGlaciTagReducer from "./delete_glaci_tag_reducer";
import DeleteOrganizationReducer from "./delete_organization_reducer";
import DeletePlaybookReducer from "./delete_playbook_reducer";
import DeleteStripeCustomerReducer from "./delete_stripe_customer_reducer";
import DeleteStripeSubscriptionReducer from "./delete_stripe_subscription_reducer";
import EnsureAuthBackendReducer from "./ensure_auth_backend_reducer";
import EnsureIdentityReducer from "./ensure_identity_reducer";
import EnsurePortalAuthReducer from "./ensure_portal_auth_reducer";
import EnsureServiceIdentityReducer from "./ensure_service_identity_reducer";
import FinishTaxEmailReducer from "./finish_tax_email_reducer";
import ImportApiKeysReducer from "./import_api_keys_reducer";
import ImportAuthDataReducer from "./import_auth_data_reducer";
import ImportGlaciOpportunitiesReducer from "./import_glaci_opportunities_reducer";
import ImportGlaciPlaybooksReducer from "./import_glaci_playbooks_reducer";
import ImportGlaciTagsReducer from "./import_glaci_tags_reducer";
import ImportIdentityLinksReducer from "./import_identity_links_reducer";
import ImportMembersReducer from "./import_members_reducer";
import ImportOpportunityAcceptPlaybooksReducer from "./import_opportunity_accept_playbooks_reducer";
import ImportOpportunityTagsReducer from "./import_opportunity_tags_reducer";
import ImportOrganizationsReducer from "./import_organizations_reducer";
import ImportPlaybookTagsReducer from "./import_playbook_tags_reducer";
import ImportSubscriptionsReducer from "./import_subscriptions_reducer";
import ImportTaxExemptionsReducer from "./import_tax_exemptions_reducer";
import ImportUsersReducer from "./import_users_reducer";
import InitializeFreshAuthBackendReducer from "./initialize_fresh_auth_backend_reducer";
import InviteMemberReducer from "./invite_member_reducer";
import RecordOrgSyncReducer from "./record_org_sync_reducer";
import RecordPipelineKeyCheckReducer from "./record_pipeline_key_check_reducer";
import RecordPlaybookSyncReducer from "./record_playbook_sync_reducer";
import RecordProLicenseCheckReducer from "./record_pro_license_check_reducer";
import RecordProductMetricSnapshotReducer from "./record_product_metric_snapshot_reducer";
import RecordTaxCustomerReducer from "./record_tax_customer_reducer";
import ReleaseTaxApprovalReducer from "./release_tax_approval_reducer";
import RemoveMemberReducer from "./remove_member_reducer";
import SetGlaciAccessRequestedReducer from "./set_glaci_access_requested_reducer";
import SetLastSelectedOrganizationReducer from "./set_last_selected_organization_reducer";
import SetOrganizationGracePeriodReducer from "./set_organization_grace_period_reducer";
import SetServiceIdentityReducer from "./set_service_identity_reducer";
import StartTaxReviewReducer from "./start_tax_review_reducer";
import UpdateCredentialMetadataReducer from "./update_credential_metadata_reducer";
import UpdateGlaciTagReducer from "./update_glaci_tag_reducer";
import UpdateMemberReducer from "./update_member_reducer";
import UpdateOrganizationReducer from "./update_organization_reducer";
import UpdatePlaybookReducer from "./update_playbook_reducer";
import UpdateUserReducer from "./update_user_reducer";

// Import all procedure arg schemas
import * as AuthBackendStatusProcedure from "./auth_backend_status_procedure";
import * as AuthPruneExpiredProcedure from "./auth_prune_expired_procedure";
import * as AuthSignInProcedure from "./auth_sign_in_procedure";
import * as AuthStorageProcedure from "./auth_storage_procedure";
import * as InviteDetailsProcedure from "./invite_details_procedure";
import * as JoinRequestNotificationProcedure from "./join_request_notification_procedure";
import * as LicenseLookupProcedure from "./license_lookup_procedure";
import * as TaxReviewQueueProcedure from "./tax_review_queue_procedure";

// Import all table schema definitions
import MyMembershipsRow from "./my_memberships_table";
import MyOrganizationsRow from "./my_organizations_table";
import MyPendingOrgsRow from "./my_pending_orgs_table";
import MyUserRow from "./my_user_table";
import OrgApiKeysRow from "./org_api_keys_table";
import OrgGlaciSyncRow from "./org_glaci_sync_table";
import OrgGlaciTagsRow from "./org_glaci_tags_table";
import OrgMembersRow from "./org_members_table";
import OrgOpportunitiesRow from "./org_opportunities_table";
import OrgOpportunityAcceptPlaybooksRow from "./org_opportunity_accept_playbooks_table";
import OrgOpportunityTagsRow from "./org_opportunity_tags_table";
import OrgPlaybookSyncRow from "./org_playbook_sync_table";
import OrgPlaybookTagsRow from "./org_playbook_tags_table";
import OrgPlaybooksRow from "./org_playbooks_table";
import OrgSubscriptionsRow from "./org_subscriptions_table";
import OrgTaxExemptionsRow from "./org_tax_exemptions_table";
import OrgUsersRow from "./org_users_table";
import StaffProductMetricsRow from "./staff_product_metrics_table";
import StaffTaxApplicationsRow from "./staff_tax_applications_table";
import SvcGlaciPlaybooksRow from "./svc_glaci_playbooks_table";
import SvcGlaciTagsRow from "./svc_glaci_tags_table";
import SvcOrganizationsRow from "./svc_organizations_table";
import SvcPlaybookTagsRow from "./svc_playbook_tags_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  my_memberships: __table({
    name: 'my_memberships',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMembershipsRow),
  my_organizations: __table({
    name: 'my_organizations',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrganizationsRow),
  my_pending_orgs: __table({
    name: 'my_pending_orgs',
    indexes: [
    ],
    constraints: [
    ],
  }, MyPendingOrgsRow),
  my_user: __table({
    name: 'my_user',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUserRow),
  org_api_keys: __table({
    name: 'org_api_keys',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgApiKeysRow),
  org_glaci_sync: __table({
    name: 'org_glaci_sync',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgGlaciSyncRow),
  org_glaci_tags: __table({
    name: 'org_glaci_tags',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgGlaciTagsRow),
  org_members: __table({
    name: 'org_members',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgMembersRow),
  org_opportunities: __table({
    name: 'org_opportunities',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgOpportunitiesRow),
  org_opportunity_accept_playbooks: __table({
    name: 'org_opportunity_accept_playbooks',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgOpportunityAcceptPlaybooksRow),
  org_opportunity_tags: __table({
    name: 'org_opportunity_tags',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgOpportunityTagsRow),
  org_playbook_sync: __table({
    name: 'org_playbook_sync',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgPlaybookSyncRow),
  org_playbook_tags: __table({
    name: 'org_playbook_tags',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgPlaybookTagsRow),
  org_playbooks: __table({
    name: 'org_playbooks',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgPlaybooksRow),
  org_subscriptions: __table({
    name: 'org_subscriptions',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgSubscriptionsRow),
  org_tax_exemptions: __table({
    name: 'org_tax_exemptions',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgTaxExemptionsRow),
  org_users: __table({
    name: 'org_users',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgUsersRow),
  staff_product_metrics: __table({
    name: 'staff_product_metrics',
    indexes: [
    ],
    constraints: [
    ],
  }, StaffProductMetricsRow),
  staff_tax_applications: __table({
    name: 'staff_tax_applications',
    indexes: [
    ],
    constraints: [
    ],
  }, StaffTaxApplicationsRow),
  svc_glaci_playbooks: __table({
    name: 'svc_glaci_playbooks',
    indexes: [
    ],
    constraints: [
    ],
  }, SvcGlaciPlaybooksRow),
  svc_glaci_tags: __table({
    name: 'svc_glaci_tags',
    indexes: [
    ],
    constraints: [
    ],
  }, SvcGlaciTagsRow),
  svc_organizations: __table({
    name: 'svc_organizations',
    indexes: [
    ],
    constraints: [
    ],
  }, SvcOrganizationsRow),
  svc_playbook_tags: __table({
    name: 'svc_playbook_tags',
    indexes: [
    ],
    constraints: [
    ],
  }, SvcPlaybookTagsRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("accept_invite", AcceptInviteReducer),
  __reducerSchema("activate_auth_backend", ActivateAuthBackendReducer),
  __reducerSchema("apply_stripe_subscription", ApplyStripeSubscriptionReducer),
  __reducerSchema("claim_tax_approval", ClaimTaxApprovalReducer),
  __reducerSchema("claim_tax_email", ClaimTaxEmailReducer),
  __reducerSchema("clear_auth_import", ClearAuthImportReducer),
  __reducerSchema("clear_playbook_sync", ClearPlaybookSyncReducer),
  __reducerSchema("complete_tax_approval", CompleteTaxApprovalReducer),
  __reducerSchema("create_api_key", CreateApiKeyReducer),
  __reducerSchema("create_glaci_tag", CreateGlaciTagReducer),
  __reducerSchema("create_join_request", CreateJoinRequestReducer),
  __reducerSchema("create_organization", CreateOrganizationReducer),
  __reducerSchema("create_playbook", CreatePlaybookReducer),
  __reducerSchema("create_tax_exemption", CreateTaxExemptionReducer),
  __reducerSchema("decline_invite", DeclineInviteReducer),
  __reducerSchema("delete_api_key", DeleteApiKeyReducer),
  __reducerSchema("delete_glaci_tag", DeleteGlaciTagReducer),
  __reducerSchema("delete_organization", DeleteOrganizationReducer),
  __reducerSchema("delete_playbook", DeletePlaybookReducer),
  __reducerSchema("delete_stripe_customer", DeleteStripeCustomerReducer),
  __reducerSchema("delete_stripe_subscription", DeleteStripeSubscriptionReducer),
  __reducerSchema("ensure_auth_backend", EnsureAuthBackendReducer),
  __reducerSchema("ensure_identity", EnsureIdentityReducer),
  __reducerSchema("ensure_portal_auth", EnsurePortalAuthReducer),
  __reducerSchema("ensure_service_identity", EnsureServiceIdentityReducer),
  __reducerSchema("finish_tax_email", FinishTaxEmailReducer),
  __reducerSchema("import_api_keys", ImportApiKeysReducer),
  __reducerSchema("import_auth_data", ImportAuthDataReducer),
  __reducerSchema("import_glaci_opportunities", ImportGlaciOpportunitiesReducer),
  __reducerSchema("import_glaci_playbooks", ImportGlaciPlaybooksReducer),
  __reducerSchema("import_glaci_tags", ImportGlaciTagsReducer),
  __reducerSchema("import_identity_links", ImportIdentityLinksReducer),
  __reducerSchema("import_members", ImportMembersReducer),
  __reducerSchema("import_opportunity_accept_playbooks", ImportOpportunityAcceptPlaybooksReducer),
  __reducerSchema("import_opportunity_tags", ImportOpportunityTagsReducer),
  __reducerSchema("import_organizations", ImportOrganizationsReducer),
  __reducerSchema("import_playbook_tags", ImportPlaybookTagsReducer),
  __reducerSchema("import_subscriptions", ImportSubscriptionsReducer),
  __reducerSchema("import_tax_exemptions", ImportTaxExemptionsReducer),
  __reducerSchema("import_users", ImportUsersReducer),
  __reducerSchema("initialize_fresh_auth_backend", InitializeFreshAuthBackendReducer),
  __reducerSchema("invite_member", InviteMemberReducer),
  __reducerSchema("record_org_sync", RecordOrgSyncReducer),
  __reducerSchema("record_pipeline_key_check", RecordPipelineKeyCheckReducer),
  __reducerSchema("record_playbook_sync", RecordPlaybookSyncReducer),
  __reducerSchema("record_pro_license_check", RecordProLicenseCheckReducer),
  __reducerSchema("record_product_metric_snapshot", RecordProductMetricSnapshotReducer),
  __reducerSchema("record_tax_customer", RecordTaxCustomerReducer),
  __reducerSchema("release_tax_approval", ReleaseTaxApprovalReducer),
  __reducerSchema("remove_member", RemoveMemberReducer),
  __reducerSchema("set_glaci_access_requested", SetGlaciAccessRequestedReducer),
  __reducerSchema("set_last_selected_organization", SetLastSelectedOrganizationReducer),
  __reducerSchema("set_organization_grace_period", SetOrganizationGracePeriodReducer),
  __reducerSchema("set_service_identity", SetServiceIdentityReducer),
  __reducerSchema("start_tax_review", StartTaxReviewReducer),
  __reducerSchema("update_credential_metadata", UpdateCredentialMetadataReducer),
  __reducerSchema("update_glaci_tag", UpdateGlaciTagReducer),
  __reducerSchema("update_member", UpdateMemberReducer),
  __reducerSchema("update_organization", UpdateOrganizationReducer),
  __reducerSchema("update_playbook", UpdatePlaybookReducer),
  __reducerSchema("update_user", UpdateUserReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("auth_backend_status", AuthBackendStatusProcedure.params, AuthBackendStatusProcedure.returnType),
  __procedureSchema("auth_prune_expired", AuthPruneExpiredProcedure.params, AuthPruneExpiredProcedure.returnType),
  __procedureSchema("auth_sign_in", AuthSignInProcedure.params, AuthSignInProcedure.returnType),
  __procedureSchema("auth_storage", AuthStorageProcedure.params, AuthStorageProcedure.returnType),
  __procedureSchema("invite_details", InviteDetailsProcedure.params, InviteDetailsProcedure.returnType),
  __procedureSchema("join_request_notification", JoinRequestNotificationProcedure.params, JoinRequestNotificationProcedure.returnType),
  __procedureSchema("license_lookup", LicenseLookupProcedure.params, LicenseLookupProcedure.returnType),
  __procedureSchema("tax_review_queue", TaxReviewQueueProcedure.params, TaxReviewQueueProcedure.returnType),
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.6.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

